import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class GradeLotNoRequest {
    @ApiProperty()
    @IsNotEmpty()
    lotNo: string;
    @ApiProperty()
    @IsNotEmpty()
    plantId: number;
    @ApiProperty()
    year:number
}